export enum Cultures {
  nl_nl = "nl-nl",
  nl_be = "nl-be",
  en_us = "en-us",
  fr_fr = "fr-fr"
}
